import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function fetchOrgChart(chartType = null, options = {}) {
  const params = [];

  if (chartType) {
    params.push(`chartType=${encodeURIComponent(chartType)}`);
  }

  if (Number.isInteger(options.maxDepth)) {
    params.push(`maxDepth=${options.maxDepth}`);
  }

  if (options.includeDetails === true) {
    params.push('includeDetails=true');
  }

  const url = params.length > 0 ? `/v1/orgChart?${params.join('&')}` : "/v1/orgChart";

  let response = await getAPIResponse(url, null, "GET");
  if (!response) {
    return [];
  }

  const flatData = flattenOrgChart(response);
  return flatData;
}

export async function fetchOrgChartNode(nodeId, options = {}) {
  const params = [];
  if (Number.isInteger(options.maxDepth)) {
    params.push(`maxDepth=${options.maxDepth}`);
  }
  if (typeof options.includeDetails === 'boolean') {
    params.push(`includeDetails=${options.includeDetails}`);
  }

  const query = params.length > 0 ? `?${params.join('&')}` : '';
  const response = await getAPIResponse(`/v1/orgChart/node/${nodeId}${query}`, null, "GET");
  if (!response) {
    return null;
  }

  return response;
}

export async function fetchOrgChartTypes() {
  const response = await getAPIResponse("/v1/orgChart/chart-types", null, "GET");
  if (!Array.isArray(response)) {
    return [];
  }

  return response.filter(Boolean);
}

function flattenOrgChart(nodes, parentId = null) {
  let result = [];

  nodes.forEach((node) => {
    const resolvedTitle = node.title || node.chartType || '';
    result.push({
      id: node.id,
      parent: parentId,
      text: resolvedTitle,
      chartType: node.chartType,
      position: node.position,
      positionId: node.positionId,
      jobPositionId: node.jobPositionId ?? null,
      isOfficialPosition: Boolean(node.isOfficialPosition),
      user: node.user,
      userId: node.userId,
      userAvatar: node.userAvatar,
      email: node.email,
      phone: node.phone,
      extension: node.extension,
      level: node.level,
      hasChildren: Boolean(node.hasChildren || (node.children && node.children.length > 0)),
      droppable: node.children && node.children.length > 0,
    });

    if (node.children && node.children.length > 0) {
      result = result.concat(flattenOrgChart(node.children, node.id));
    }
  });

  return result;
}
